import { WelcomeForm } from "~/components/user/WelcomeForm/WelcomeForm";
export default WelcomeForm;
